import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { useId } from 'react'
import { cn } from '@cannect/lib/utils'
import { recurrencyCopy } from '../copy'

type CycleSelectorProps = {
  options: number[]
  value: number | null
  suggested?: number | null
  onChange: (cycleDays: number) => void
  labels?: Partial<Record<number, string>>
  label?: string
  disabled?: boolean
  className?: string
}

// Chips de ciclo (60/90/120): radio group do Radix, setas do teclado trocam a opção.
export const CycleSelector = ({
  options,
  value,
  suggested,
  onChange,
  labels = {},
  label = recurrencyCopy.purchase.cycleLabel,
  disabled = false,
  className
}: CycleSelectorProps) => {
  const labelId = useId()

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <span id={labelId} className="text-sm font-semibold text-gray-800">
        {label}
      </span>
      <RadioGroupPrimitive.Root
        aria-labelledby={labelId}
        value={value ? String(value) : undefined}
        onValueChange={(next) => onChange(Number(next))}
        disabled={disabled}
        orientation="horizontal"
        className="flex flex-wrap gap-2">
        {options.map((days) => (
          <RadioGroupPrimitive.Item
            key={days}
            value={String(days)}
            aria-label={`${recurrencyCopy.purchase.cycleOption(days)}${labels[days] ? ` · ${labels[days]}` : ''}${
              suggested === days ? ' (sugerido)' : ''
            }`}
            className={cn(
              'flex min-w-[104px] flex-col items-center rounded-lg border border-solid border-gray-300 bg-white px-4 py-2 text-gray-800 transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2',
              'disabled:cursor-not-allowed disabled:opacity-50',
              'data-[state=checked]:border-primary-700 data-[state=checked]:bg-primary-700 data-[state=checked]:text-white'
            )}>
            <span className="text-base font-semibold">{recurrencyCopy.purchase.cycleOption(days)}</span>
            {labels[days] && <span className="text-xs">{labels[days]}</span>}
          </RadioGroupPrimitive.Item>
        ))}
      </RadioGroupPrimitive.Root>
    </div>
  )
}
